import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AgentService } from '../services/agent.service';
import { AgentPartyDetailsHandlerComponent } from './agent-party-details.handler';

@Component({
  selector: 'sym-agent-party-details',
  templateUrl: './agent-party-details.component.html',
  styleUrls: ['./agent-party-details.component.scss'],
})
export class AgentPartyDetailsComponent extends AgentPartyDetailsHandlerComponent {
  constructor(agentService: AgentService) {
    super(agentService);
  }
}
